
import { Component, Watch, Vue } from 'vue-property-decorator';
import CommonFooter from './CommonFooter.vue';
import store from '@/store';
// @ is an alias to /src

@Component({
  components: {
    CommonFooter
  }
})
export default class CommonFooterJa extends Vue {
  private name = 'commonFooter';
  get lang(): string {
    return store.getters['auth/lang'];
  }
  get isLogin(): boolean {
    return !!store.getters['auth/token'];
  }
  get isLine(): boolean {
    return !!store.getters['auth/line'];
  }
  private async onClickUnRegister(){
    await store.dispatch('auth/lineDelete')
    window.location.reload();
  }
}
